export const NewBadge = ({ show }) =>
  show ? (
    <span
      data-testid="new-badge"
      className="absolute top-2 left-2 rounded-full bg-primary text-white text-[10px] font-bold tracking-wide px-2 py-1 shadow-sm"
    >
      NEW
    </span>
  ) : null;
